const currenciesData = [
  { code: 'gbp', name: 'British Pound (GBP)', symbol: '£', minimum: 100, maximum: 10000000 },
  { code: 'usd', name: 'US Dollar (USD)', symbol: '$' , minimum: 100, maximum: 10000000 },
  { code: 'eur', name: 'Euro (EUR)', symbol: '€' , minimum: 100, maximum: 10000000 },
  { code: 'aud', name: 'Australian Dollar (AUD)', symbol: 'A$' , minimum: 100, maximum: 10000000 },
  { code: 'cad', name: 'Canadian Dollar (CAD)', symbol: 'C$' , minimum: 100, maximum: 10000000 },
  { code: 'nzd', name: 'New Zealand Dollar (NZD)', symbol: 'NZ$', minimum: 100, maximum: 10000000  }
]

// Note for the minimum, it must convert to greater than or equal to the minimum amount in the connected stripe account's settlement currency
// e.g. if settlement currency is USD, minimum is $0.50, so for EUR (approx 0.90USD) the minimum would be 0.50 / 0.90 = ~0.56 EUR, we set to 100 minor units (1.00 EUR) to be safe and simple
// https://docs.stripe.com/currencies#minimum-and-maximum-charge-amounts

export default currenciesData
